"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 16v2h20v-2zm0-5v2h20v-2zm0-5v2h20V6z"
}), 'DehazeTwoTone');